module.exports = __webpack_public_path__ + "static/img/Banner@2x.383920a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/MYBANK/Banner@2x.png
// module id = WzhG
// module chunks = 70